import {
  SECURITY_ROLES,
  type OperationalProfile,
  type SecurityRole,
} from '../../authorization/model.js';

export const AUTH_ROLES = SECURITY_ROLES;

export type AuthRole = SecurityRole;

export interface AuthenticatedUser {
  subjectId: string;
  tenantId: string;
  tenantName: 'Positive Output';
  displayName: string;
  email: string;
  roles: readonly AuthRole[];
  role: AuthRole;
  operationalProfile: OperationalProfile;
}

export type AuthState =
  | { status: 'INITIALIZING' }
  | { status: 'UNAUTHENTICATED'; message?: string }
  | { status: 'ACCESS_DENIED'; message: string }
  | { status: 'AUTHENTICATION_ERROR'; message: string }
  | { status: 'AUTHENTICATED'; user: AuthenticatedUser };

export interface AuthProvider {
  getState(): AuthState;
  subscribe(listener: (state: AuthState) => void): () => void;
  initialize(): Promise<void>;
  refreshSession(): Promise<void>;
  getIdentityToken(): Promise<string | null>;
  signIn(): Promise<void>;
  signOut(): Promise<void>;
}
